import images from "./images";

const services = [
    {
        image: `${images.services_img_1}`,
        title: "Web Design & Maintenance",
        paragraph: "We specialize in creating stunning and user-friendly websites. Our team ensures a seamless user experience from wireframing to prototyping and final design. Additionally, we offer reliable website maintenance services to keep your site up-to-date and running smoothly."
    },
    {
        image: `${images.services_img_2}`,
        title: "Branding & SEO/SEM",
        paragraph: "Building a strong brand identity is crucial for any business. We help you establish a brand personality, design logos, and develop brand guidelines. Our expertise also extends to Search Engine Optimization (SEO) and Search Engine Marketing (SEM) strategies to boost your online presence and attract more customers."
    },
    {
        image: `${images.services_img_3}`,
        title: "UX Design",
        paragraph: "User experience is at the heart of every successful product. We conduct thorough research and create intuitive interfaces to ensure your users have a delightful experience. With our UX design expertise, your digital products will be optimized for maximum user engagement and satisfaction."
    },
    {
        image: `${images.services_img_4}`,
        title: "Logo Creation & Software training",
        paragraph: "Your logo is the face of your business. We craft unique and memorable logos that represent your brand's values and make a strong impact on your target audience. In addition to logo creation, we offer software courses to empower your team with essential digital skills."
    },
    {
        image: `${images.services_img_5}`,
        title: "Illustration & Social Networks",
        paragraph: "From custom illustrations to vector graphics, we bring your ideas to life. Whether it's for your website, marketing materials, or products, our artistic visuals captivate your audience. We also provide expert social media management and marketing services to enhance your brand's presence and engagement."
    },
    {
        image: `${images.services_img_6}`,
        title: "Advisory and Consulting Services",
        paragraph: "Visual communication is essential in today's digital world. We design eye-catching graphics for social media, ads, and promotional materials to help you stand out from the crowd. Our advisory and consulting services provide valuable insights and strategies to optimize your digital marketing efforts and drive business growth."
    },
];

const works = [
    {
        image: `${images.shoes_website}`
    },
    {
        image: `${images.work_img_2}`
    },
    {
        image: `${images.work_img_3}`
    },
    {
        image: `${images.work_img_4}`
    },
    {
        image: `${images.work_img_5}`
    },
    {
        image: `${images.work_img_6}`
    },
];

const work_process = [
    {
        title: "Sketch",
        paragraph: "In the sketch phase, we gather your requirements and ideas to create rough sketches and wireframes. This helps us visualize the layout and structure of the project before moving forward with the design."
    },
    {
        title: "Design",
        paragraph: "In the design phase, we take the approved sketches and wireframes and turn them into visually appealing mockups. We pay attention to every detail, ensuring the aesthetics align with your brand identity and user preferences."
    },
    {
        title: "Develop",
        paragraph: "In the development phase, we start building the actual product based on the approved designs. Our team of developers follows best practices to create a robust and efficient solution tailored to your specific needs."
    },
    {
        title: "End-Product",
        paragraph: "In the end-product phase, we conduct thorough testing to ensure the product meets the highest quality standards. Once everything is thoroughly reviewed and approved, we deliver the final product to you."
    },
];

const about_stats = [
    {
        image: `${images.stat_img_1}`,
        value: "+150",
        title: "Clients"
    },
    {
        image: `${images.stat_img_2}`,
        value: "+25",
        title: "Projects"
    },
    {
        image: `${images.stat_img_3}`,
        value: "+4000",
        title: "Working Hours"
    },
    {
        image: `${images.stat_img_4}`,
        value: "+15",
        title: "Awards"
    },
];

const testimonials = [
    {
        name: "Lelia Merritt",
        post: "Graphic Designer",
        paragraph: "Working with this designer has been a pleasure. Their creative vision and attention to detail have elevated our brand and marketing materials to new heights. Highly recommended!"
    },
    {
        name: "John Huston",
        post: "Web Developer",
        paragraph: "I'm impressed with the level of professionalism and technical expertise this web developer brings to the table. They were able to turn our complex requirements into a seamless and responsive website."
    },
    {
        name: "Jeniffer Green",
        post: "Marketing Manager",
        paragraph: "This designer understands our brand and marketing goals like no one else. Their creativity and strategic thinking have been instrumental in driving our marketing campaigns to success."
    },
];

const logos = [
    {
        image: `${images.logo_img_1}`
    },
    {
        image: `${images.logo_img_2}`
    },
    {
        image: `${images.logo_img_3}`
    },
    {
        image: `${images.logo_img_4}`
    },
    {
        image: `${images.test_img_5}`
    },
    {
        image: `${images.test_img_6}`
    },
];

export {services, works, work_process, about_stats, testimonials, logos};
